import { useEffect, useState } from 'react';

// The store designs take each demo store's live theme colour (GET /api/demo-stores), so a colour changed in the admin
// panel shows on ownezzy.com too. The colours in Hero.js are used until it loads, or if it can't.
const HEX = /^#[0-9a-f]{6}$/i;

const channel = (color, i) => parseInt(color.slice(1 + i * 2, 3 + i * 2), 16);

// Blends a #rrggbb colour towards another; weight 0 keeps the colour, 1 gives the other (as in the storefront's theme.js)
function mix(color, other, weight) {
  return `#${[0, 1, 2].map((i) => Math.round(channel(color, i) * (1 - weight) + channel(other, i) * weight).toString(16).padStart(2, '0')).join('')}`;
}

// main: the store's colour; soft and warm: the light tints the slides and cards are painted with. A light colour
// (PawPantry's bright yellow) is too pale for text and white-text buttons, so main is a deep shade of it.
const isLight = (color) => channel(color, 0) * 0.299 + channel(color, 1) * 0.587 + channel(color, 2) * 0.114 > 200;
const themeFor = (color) => ({
  main: isLight(color) ? mix(color, '#000000', 0.5) : color,
  soft: mix(color, '#ffffff', isLight(color) ? 0.7 : 0.9),
  warm: mix(mix(color, '#ffb347', 0.5), '#ffffff', 0.82),
});

// One request for the whole page, shared by the hero slider and the design cards
let colors = null;
const loadColors = () => {
  if (!colors) {
    colors = fetch('/api/demo-stores')
      .then((res) => (res.ok ? res.json() : { stores: [] }))
      .then((data) => Object.fromEntries((data.stores || []).filter((s) => HEX.test(s.color || '')).map((s) => [s.template, s.color.toLowerCase()])))
      .catch(() => ({}));
  }
  return colors;
};

// The templates with their live colours
export default function useDemoThemes(templates) {
  const [live, setLive] = useState(null);
  useEffect(() => {
    let active = true;
    loadColors().then((found) => active && setLive(found));
    return () => { active = false; };
  }, []);
  if (!live) return templates;
  return templates.map((t) => {
    const color = live[t.template || t.id];
    return color && color !== String(t.theme.main).toLowerCase() ? { ...t, theme: themeFor(color) } : t;
  });
}
